import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const getSuppliesInventoryConfigsCount = unaryRpc({
  name: "getSuppliesInventoryConfigsCount" as const,
  input: z.object({}),
  output: z.object({ total: z.number() }),
});
